// extracted by mini-css-extract-plugin
export var root = "H_vM";
export var wrapper = "H_vN";
export var image = "H_vP d_w d_y d_W";
export var imageWithHeight = "H_vQ";
export var crop = "H_vR";
export var round = "H_vS";
export var fixedHeight = "H_vT";